module.exports = __webpack_public_path__ + "static/media/logo.b913a8a9.svg";